<app-header></app-header>
<div class="container">
    <div class="guest-app-container width100" fxLayout="row">
        <div class="guest-app-child" fxLayout="column" fxLayoutGap="2%">
            <div fxLayout="row">
                <button class="online-button">
                    <ul class="custom-list">
                        <li>Virtual concierge app
                        </li>
                    </ul>
                </button>
            </div>
            <h2 class="guest-app-child-heading">E-Concierge: Your Guests' Digital Guide</h2>
            <div *ngIf="mobile" style="align-items: center;">
                <img class="image" src="/assets/images/Virtual concierge app.png" />
            </div>
            <div class="guest-app-child-text">GoFriday’s E-Concierge app enhances the guest experience with seamless
                access to personalized recommendations, service requests, and local recommendations—all available 24/7
                from a smartphone or tablet.
            </div>
            <div class="buttons">
                <button class="book-btn" (click)="openCalendlyPopup()">
                    Book A Demo Today
                </button>
                <button class="demo-link" (click)="selectTrial()">
                    Talk to Us
                    <iconify-icon icon="material-symbols:arrow-right-alt" class="arrow-icon"></iconify-icon>
                </button>
            </div>
        </div>
        <div class="image-container" *ngIf="!mobile">
            <img class="image" src="/assets/images/Virtual concierge app.png" />
        </div>
    </div>
    <div class="info-container1 width100" fxLayout="column" fxLayoutAlign="center center">
        <h2 class="guest-app-child-heading2">
            What is GoFriday’s E-Concierge?
        </h2>
        <div class="guest-app-child-text2">
            E-Concierge puts the traditional concierge at guests' fingertips.
            Integrated into the GoFriday Guest App, it offers local recommendations and tailored services for a seamless
            stay
        </div>
        <div fxLayout="column" class="why-choose-content-container">
            <h3 class="guest-app-child-heading2" style="padding-bottom: 5%;">
                Features of E-Concierge
            </h3>
            <div fxLayout="row" fxLayoutGap="4%" class="why-choose-content">
                <div class="member-div" fxLayout="column" fxLayoutGap="1%" fxLayoutAlign="center center">
                    <img class="choose-image" src="/assets/images/Digital Access.png" alt="" />
                    <h3 class="why-choose-content-head">
                        Local Expertise, Digital Access
                    </h3>
                    <div class="why-choose-text">Offer curated recommendations for dining, entertainment, and
                        sightseeing, tailored to guests’ preferences.
                    </div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/Guest Assistance.png" alt="" />
                    <h3 class="why-choose-content-head">
                        24/7 Guest Assistance
                    </h3>
                    <div class="why-choose-text">Allow guests to request services like transportation, dining
                        reservations, or special arrangements anytime, anywhere.</div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/Personalized Suggestions.png" alt="" />
                    <h3 class="why-choose-content-head">
                        Personalized Suggestions
                    </h3>
                    <div class="why-choose-text">Provide smart, AI-driven suggestions based on guest profiles, travel
                        purpose, and stay history.
                    </div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/Interactive Maps.png" alt="" />
                    <h3 class="why-choose-content-head">
                        Interactive Maps
                    </h3>
                    <div class="why-choose-text">Help guests explore local attractions with integrated maps and
                        step-by-step directions.
                    </div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/Event Bookings.png" alt="" />
                    <h3 class="why-choose-content-head">
                        Event Bookings Made Easy
                    </h3>
                    <div class="why-choose-text">Enable guests to book tickets, tours, or spa treatments directly
                        through the app, with real-time availability and confirmations.
                    </div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/Multilingual Support.png" alt="" />
                    <h3 class="why-choose-content-head">
                        Multilingual Support
                    </h3>
                    <div class="why-choose-text">Break down language barriers with support for multiple languages,
                        ensuring inclusivity for all guests.
                    </div>
                </div>
            </div>
        </div>
        <h2 class="guest-app-child-heading2">
            Benefits For Your Hotel
        </h2>
        <div class="benefits-container">
            <div class="benefit" fxLayout="column" fxLayoutAlign="center center">
                <div class="benefit-number">01</div>
                <h3>Enhanced Guest Experience</h3>
                <p>Deliver personalized, real-time assistance to make every stay exceptional.</p>
            </div>
            <mat-divider *ngIf="!mobile"></mat-divider>
            <div class="benefit" fxLayout="column" fxLayoutAlign="center center">
                <div class="benefit-number">02</div>
                <h3>Operational Efficiency</h3>
                <p>Reduce pressure on your front desk and concierge team while maintaining superior service.
                </p>
            </div>
            <mat-divider *ngIf="!mobile"></mat-divider>
            <div class="benefit" fxLayout="column" fxLayoutAlign="center center">
                <div class="benefit-number">03</div>
                <h3>Revenue Growth</h3>
                <p>Highlight and promote your hotel’s premium offerings, like dining, events, or local partnerships.</p>
            </div>
            <mat-divider *ngIf="!mobile"></mat-divider>
            <div class="benefit" fxLayout="column" fxLayoutAlign="center center">
                <div class="benefit-number">04</div>
                <h3>Stronger Guest Connections</h3>
                <p>Build loyalty by offering a concierge experience tailored to each guest.</p>
            </div>
        </div>
    </div>
    <div class="info-container3 width100" fxLayout="column" fxLayoutAlign="center center">
        <div style="background: #F9F9F9;width: 100%;">
            <div class="features-section2" fxLayout="column" *ngIf="!mobile">
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5%">
                    <div class="features-image-container-left">
                        <img class="features-images" src="assets/images/E-Concierge Experience.png">
                    </div>
                    <div fxLayout="column" fxFlex="44%" fxLayoutGap="2%">
                        <h2 class="features-heading">
                            The E-Concierge Experience
                        </h2>
                        <div fxLayout="column" fxLayoutGap="1%">
                            <div class="features-sub-heading">
                                Easy Access
                            </div>
                            <div class="features-sub-text">
                                Guests open the E-Concierge feature on their smartphones or in-room devices.
                            </div>
                        </div>
                        <div fxLayout="column" fxLayoutGap="1%">
                            <div class="features-sub-heading">
                                Personalized Interaction
                            </div>
                            <div class="features-sub-text">
                                They explore curated recommendations or request custom assistance.
                            </div>
                        </div>
                        <div fxLayout="column" fxLayoutGap="1%">
                            <div class="features-sub-heading">
                                Immediate Fulfillment
                            </div>
                            <div class="features-sub-text">
                                Requests are routed to the appropriate team through the GoFriday Task App for prompt
                                action.
                            </div>
                        </div>
                        <div fxLayout="column" fxLayoutGap="1%">
                            <div class="features-sub-heading">
                                Memorable Stay
                            </div>
                            <div class="features-sub-text">
                                Guests enjoy tailored, thoughtful services that elevate their travel experience.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="center center" *ngIf="mobile">
                <div fxLayout="column" fxLayoutAlign="space-between center">
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 4% 5% 3% 5%;">
                        <h2 class="features-heading">
                            The E-Concierge Experience
                        </h2>
                    </div>
                    <div class="features-image-container-left">
                        <img class="features-images" src="assets/mobile-images/E-Concierge Experience.png">
                    </div>
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 15% 5% 5% 5%;">
                        <div class="features-sub-heading">
                            Easy Access
                        </div>
                        <div class="features-sub-text">
                            Guests open the E-Concierge feature on their smartphones or in-room devices.
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 2% 5% 5% 5%;">
                        <div class="features-sub-heading">
                            Personalized Interaction
                        </div>
                        <div class="features-sub-text">
                            They explore curated recommendations or request custom assistance.
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 2% 5% 5% 5%;">
                        <div class="features-sub-heading">
                            Immediate Fulfillment
                        </div>
                        <div class="features-sub-text">
                            Requests are routed to the appropriate team through the GoFriday Task App for prompt
                            action.
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 2% 5% 5% 5%;">
                        <div class="features-sub-heading">
                            Memorable Stay
                        </div>
                        <div class="features-sub-text">
                            Guests enjoy tailored, thoughtful services that elevate their travel experience.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div fxLayout="row" class="info-container1 width100" fxLayoutAlign="space-between center" *ngIf="!mobile">
        <div fxFlex="48%" fxLayout="column" fxLayoutGap="1%">
            <div>
                <h2 class="header">Integrated with GoFriday’s Guest Experience Ecosystem</h2>
            </div>
            <div class="info-text">
                E-Concierge isn’t just a standalone feature-it works seamlessly with GoFriday’s Guest App, Task
                Management App, and PMS Dashboard to create a cohesive, guest-centric ecosystem that redefines
                hospitality.
            </div>
        </div>
        <div class="contact-image" fxFlex="40%">
            <img src="assets/images/Guest Experience Ecosystem.png">
        </div>
    </div>
    <div fxLayout="column" class="info-container1 width100" fxLayoutAlign="center center" *ngIf="mobile">
        <div>
            <div>
                <h2 class="header">Integrated with GoFriday’s Guest Experience Ecosystem</h2>
            </div>
            <div class="contact-image" style="text-align:center;">
                <img src="assets/mobile-images/Integrated Guest Experience Ecosystem.png">
            </div>
            <div class="info-text">
                E-Concierge isn’t just a standalone feature-it works seamlessly with GoFriday’s Guest App, Task
                Management App, and PMS Dashboard to create a cohesive, guest-centric ecosystem that redefines
                hospitality.
            </div>
        </div>
    </div>


    <div fxLayout="row" class="info-container4 width100" fxLayoutAlign="space-between center" *ngIf="!mobile">
        <div class="contact-image" fxFlex="50%">
            <img class="bottom-image" src="assets/images/Transform Guest Assistance.png">
        </div>
        <div fxFlex="45%" fxLayout="column" fxLayoutGap="1%">
            <div>
                <h2 class="header">Transform Guest Assistance with E-Concierge</h2>
            </div>
            <div class="info-text">
                Deliver the ultimate in guest convenience and satisfaction. GoFriday’s E-Concierge makes it easy
                to
                provide 5-star service digitally while optimizing your hotel’s operations.
            </div>
            <div style="margin-top: 3%;">
                <button class="book-btn" (click)="openCalendlyPopup()">
                    Book A Demo Today
                </button>
            </div>
        </div>
    </div>

    <div fxLayout="column" class="info-container4 width100" fxLayoutAlign="center center" *ngIf="mobile">
        <div>
            <div>
                <h2 class="header">Transform Guest Assistance with E-Concierge</h2>
            </div>
            <div class="contact-image" *ngIf="mobile" style="text-align: center;">
                <img src="assets/mobile-images/Transform Guest Assistance.png">
            </div>
            <div class="info-text">
                Deliver the ultimate in guest convenience and satisfaction. GoFriday’s E-Concierge makes it easy
                to
                provide 5-star service digitally while optimizing your hotel’s operations.
            </div>
            <div style="margin-top: 3%;text-align: center;">
                <button class="book-btn" (click)="openCalendlyPopup()">
                    Book A Demo Today
                </button>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>